import { RemoveJob } from "@domain/models/RemoveJob";
import RemoveRepository from "@domain/repositories/RemoveRepository";
import UseCase from "@domain/UseCase";

type Input = void;

type Output = Promise<RemoveJob>;

export class RemoveOldClientsUseCase implements UseCase<Input, Output> {
  constructor(private readonly httpClientRepository: RemoveRepository) {}

  execute() {
    return this.httpClientRepository.removeOldClients();
  }
}
